import { RootState } from 'App';
import deepEqualsCreateSelector from 'utils/deepEqualsCreateSelector';

const selectedSettings = ({ settings }: RootState) => settings;

export const selectAccountSettings = deepEqualsCreateSelector(
  [selectedSettings], ({ accountSettings }) => accountSettings,
);

export const selectPolicySettings = deepEqualsCreateSelector(
  [selectedSettings], ({ policySettings }) => policySettings,
);

export const selectStoreSettings = deepEqualsCreateSelector(
  [selectedSettings], ({ storeSettings }) => storeSettings,
);

export const selectPaymentsSettings = deepEqualsCreateSelector(
  [selectedSettings], ({ paymentsSettings }) => paymentsSettings,
);

export const selectAccountSettingsMeta = deepEqualsCreateSelector(
  [selectAccountSettings], ({ meta }) => meta || {},
);

export const selectLastSyncProductsDate = deepEqualsCreateSelector(
  [selectStoreSettings, selectAccountSettingsMeta],
  ({ productsSyncDate }, meta) => productsSyncDate ?? meta.productsSyncDate,
);
